import classnames from 'classnames';
import { FC, ForwardedRef, forwardRef, HTMLAttributes, ReactNode } from 'react';

type TagNames = 'div' | 'dl';

export type RowProps = {
  children?: ReactNode;
  className?: string;
  component?: TagNames;
};

type Element = HTMLDivElement & HTMLDListElement;

type ComponentProps = {
  tagName?: TagNames;
  children: ReactNode;
  ref?: ForwardedRef<Element>;
} & HTMLAttributes<Element>;

const Component: FC<ComponentProps> = ({
  tagName: Wrapper = 'div',
  children,
  ...rest
}) => <Wrapper {...rest}>{children}</Wrapper>;

export const Row: FC<RowProps> = forwardRef<Element, RowProps>(
  ({ children, className, component }, ref) => (
    <Component
      tagName={component}
      className={classnames(className || '', 'row')}
      ref={ref}>
      {children}
    </Component>
  )
);
